module.exports = __webpack_public_path__ + "b645fda76c34402c35882904988eb160.ttf";